import styles from './Appeal.module.css'
import React, {JSX, useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import TableItem, {
    TableItemColumnInt,
    TableItemCurrentStateInt,
    TableItemDataItemInt
} from "../../FormTemplate/TableItem/TableItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import {async} from "rxjs";
import {Link, useNavigate} from "react-router-dom";



interface AppealVisibleInt
{
    id:number
    visible:boolean
}
interface UpdateTarifGlobalInt
{
    id:number
    fieldList: string[]
    valList: any[]
}

interface AppealReplyInt
{
    sourceId: number
    sourceText:string
    text: string
}

interface AppealRemoveInt
{
    id: number
    comment?:string
}


interface AppealListTreeInt
{
   id:number
}
interface AppealItemInt
{
    type:number
    show:boolean
    text:string
    author:string
    parent:number
    id:number
    createdAt:string
    xData?:string
    yData?:string
    [key:string]:any
}

export default function Appeal(){

    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const appealErrorLine = useRef<ErrorLineItemRef>(null)

    const navigate = useNavigate()

    const appealData = useRef()
    const [ldrAppeal,rsAppeal,exAppeal] = useApiQuery("/appeal/list/root","post",appealData);
    const [appealList, setAppealList] = useState<AppealItemInt[]>([])

    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()

    const updateAppealData = useRef<UpdateTarifGlobalInt>()
    const [ldrUpdateAppeal,rsUpdateAppeal,exUpdateAppeal] = useApiQuery("/appeal/update","post",updateAppealData);


    const [currentAppeal,setCurrentAppeal] = useState<AppealItemInt>()

    const [currentRootAppeal,setCurrentRootAppeal] = useState<AppealItemInt | undefined>(undefined)
    const [appealReply, setAppealReply] = useState("")


    const appealListTreeData = useRef<AppealListTreeInt>()
    const [ldrAppealListTree,rsAppealListTree,exAppealListTree] = useApiQuery("/appeal/list/tree","post",appealListTreeData);
    const [appealListTree, setAppealListTree] = useState<AppealItemInt[]>([])


    const appealReplyData = useRef<AppealReplyInt>()
    const [ldrAppealReply,rsAppealReply,exAppealReply] = useApiQuery("/appeal/reply","post",appealReplyData);

    const appealRemoveData = useRef<AppealRemoveInt>()
    const [ldrAppealRemove,rsAppealRemove,exAppealRemove] = useApiQuery("/appeal/remove","post",appealRemoveData);

    const appealFixData = useRef<AppealRemoveInt>()
    const [ldrAppealFix,rsAppealFix,exAppealFix] = useApiQuery("/appeal/fix","post",appealFixData);

    const appealVisibleData = useRef<AppealVisibleInt>()
    const [ldrAppealVisible,rsAppealVisible,exAppealVisible] = useApiQuery("/appeal/visible","post",appealVisibleData);


    const [comment, setComment] = useState("")

    const [fltrAppealList, setFltrAppealList] = useState<AppealItemInt[]>([])

    const [showReply, setShowReply] = useState(false)

    const [showEdit, setShowEdit] = useState(false)


    const tableColumn:TableItemColumnInt[] = [
        {
            title:"Источник",
            mode: "fs",
            type:0,
            fieldId:"typeText",
            maxLen: 30,
        },
        {
            title:"Автор",
            mode: "f",
            type:0,
            fieldId:"author",
            maxLen: 30,
        },
        {
            title:"Телефон",
            mode: "f",
            type:0,
            fieldId:"phone",
        },
        {
            title:"e-Mail",
            mode: "f",
            type:0,
            fieldId:"eMail",
            maxLen: 30,
        },
        {
            title:"Текст",
            mode: "",
            type:0,
            fieldId:"text",
            maxLen: 30,
        },
        {
            title:"xData",
            mode: "f",
            type:0,
            fieldId:"xData",
            maxLen: 30,
        },
        {
            title:"yData",
            mode: "f",
            type:0,
            fieldId:"yData",
            maxLen: 30,
        },
        {
            title:"Создан",
            mode: "fs",
            type:4,
            fieldId:"createdAt",
            maxLen: 30,
        },
        {
            title:"Ответ",
            mode: "s",
            type:5,
            fieldId:"reply",
            maxLen: 30,
        },

    ]

    useEffect(()=>{
        loadTree()
    },[currentRootAppeal])

    useEffect(()=>{
        loadAppealList()
    },[appealData])

    useEffect(()=>{
        console.log("curr appeal", currentRootAppeal)
    },[currentRootAppeal])


    const loadAppealList = ()=>{
        exAppeal().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                setAppealList(e?.payload)
                setFltrAppealList(e?.payload)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)
        })

    }




    const buildTree = (item: AppealItemInt, id:number, level:number) =>{
        let sb = appealListTree?.filter((item)=>item?.parent === id )
        sb = sb?.sort((a,b)=>{
            const dtA = new Date(a?.createdAt)
            const dtB = new Date(b?.createdAt)
            if(dtA < dtB) return -1
            if(dtA >  dtB) return 1
            return  0
        })


        let shRemove = true
        let shReply= true
        let moveToOrder = true

        let showAddInfo = false
        let addInfo = ""
        let text = item?.text
        switch (currentRootAppeal?.type)
        {
            case 6:
                addInfo = `телефон клиента [ ${item?.yData} ]`
                showAddInfo = true
                moveToOrder = false
                if(level>0)
                {
                    shReply = false
                }

                break
            case 5:
                addInfo = `комментарий [ ${item?.yData} ]`
                showAddInfo = item?.yData ? true: false
                break

            case 4:
                if(level ===0 )
                {
                    addInfo = `реквизиты для возврата [ ${item?.yData} ]`
                    showAddInfo = true
                }
                break

            case 0:
            case 1:
                addInfo = `комментарий [ ${item?.yData} ]`
                showAddInfo = item?.yData ? true: false
                moveToOrder = false
                if(level>0)
                {
                    shReply = false
                }
                break
        }

        const dt = new Date(item?.createdAt).toLocaleString()
        return(
            <>
                <div className={styles.appSub} style={{marginLeft:((level+1)*10)+"px"}}>

                    <div className={styles.titleLine}>
                        <span className={styles.appAuthor}>{item?.author}</span>
                        <div className={styles.appBox} style={{marginRight:"5px"}}><input type={"checkbox"} checked={item?.show}
                            onChange={(e)=>handleVisible(item?.id,e.target.checked)}
                        /></div>
                        <div>{dt}</div>
                        {shReply &&
                            <div className={styles.appBox}
                                 onClick={()=>{
                                     setCurrentAppeal(item)
                                     setShowReply(true)
                                 }}
                            ><i className='bx bx-registered'></i></div>
                        }

                        {moveToOrder && item?.xData && level===0 &&
                            <Link to={`/lk/order/${item?.xData}`} target={"_blank"}>
                                <div className={styles.appBox}>
                                    <i className='bx bx-receipt'></i>
                                </div>

                            </Link>

                        }


                        <div className={styles.appBox}
                            onClick={()=>handleRemove(item?.id, level)}
                        ><i className={"bx bxs-trash-alt"}></i></div>

                    </div>

                    <div className={styles.apText}>{text}</div>
                    {showAddInfo && <div className={styles.apTextAdd}>{addInfo}</div>}
                    <hr className={styles.appHr}></hr>
                    {sb?.map((itm,idx)=>{
                        return buildTree(itm,itm?.id,level+1)

                    })}

                </div>

            </>
        )
    }


    const handleFix = () =>{
        if(!currentAppeal) return
        appealFixData.current = {
            id: currentAppeal?.id,
            comment: comment?.length ? comment : undefined
        }
        exAppealFix().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine?.current)appealErrorLine?.current?.show("Обращение закрыто",false,2000)
                setShowReply(false)
                loadTree()
                updateReplyState(currentAppeal?.id)


/*                setTimeout(()=>
                {
                    setShowReply(false)
                    loadTree()
                },2500)*/
                return
            }
            if(appealErrorLine?.current)appealErrorLine?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        }).catch((e)=>{
            if(appealErrorLine?.current)appealErrorLine?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        })

    }

    const handleVisible = (id: number, visible:boolean) => {
        appealVisibleData.current = {
            id: id,
            visible: visible
        }
        exAppealVisible().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show("Статус сменен",false,3000)
                loadTree()
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка смены статуса",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка смены статуса",true,5000)

        })
    }
    const handleRemove = (id: number, level:number)=>  {
        const quest = window.confirm("Вы уверены что хотите удалить комментарий?")
        if(! quest) return
        appealRemoveData.current = {
            id: id
        }
        exAppealRemove().then((e)=>{
            if(e?.success)
            {

                if(errorLineRef?.current)errorLineRef?.current?.show("Событие удалено",false,3000)
                if(level === 0)
                {
                    loadAppealList()
                }

                loadTree()
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка удаления",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка удаления",true,5000)

        })
    }
    const handleReply = () =>{
        if(!currentAppeal) return;
        if(appealReply.length < 2)
        {
            if(appealErrorLine?.current)appealErrorLine?.current.show("Не корректный ответ",true,2000)
            return
        }
        appealReplyData.current = {
            sourceId: currentAppeal?.id,
            sourceText: currentAppeal?.text,
            text: appealReply
        }
        exAppealReply().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine?.current)appealErrorLine?.current?.show("Ответ отправлен",false,2000)
                //loadTree(currentRootAppeal)
                setShowReply(false)
                loadTree()
                updateReplyState(currentAppeal?.id)

/*                setTimeout(()=>
                {
                    setShowReply(false)
                    loadTree()
                },2500)*/
                setAppealReply("")
                return
            }
            if(appealErrorLine?.current)appealErrorLine?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        }).catch((e)=>{
            if(appealErrorLine?.current)appealErrorLine?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        })
    }

    const buildReplyJSX = (type:number)=>{
        if(currentAppeal === undefined) return null
        switch (type)
        {
            case 0:
            case 2:
            case 3:
            case 4:
                return(
                    <MainFormTemplate title={`Обработка события`} maxWidth={"500px"} background={"white"}>
                        <div className={"row mt-3"}>
                            <div className={"col-lg-12"}>
                                <InputItem
                                    val={currentAppeal?.text }
                                    mode={"ei"}
                                    info={"Текст обращения"}
                                    title={""}
                                    titleShift={-6}
                                    inputType={2}
                                    lineCount={5}
                                    placeHolder={"Текст обращения"}
                                    onChange={(e)=>setCurrentAppeal({...currentAppeal, text:e})}
                                ></InputItem>
                            </div>

                        </div>
                        <div className={"row"}>
                            <div className={styles.rpCont}>
                                <div
                                    onClick={()=>setAppealReply(`${appealReply} Добрый день.`)}
                                >Добрый день.</div>
                                <div
                                    onClick={()=>setAppealReply(`${appealReply} Принято.`)}
                                >Принято</div>
                                <div
                                    onClick={()=>setAppealReply(`${appealReply} Номер активирован.`)}
                                >Номер активирован</div>
                            </div>
                        </div>
                        <div className={"row mt-3"}>
                            <div className={"col-lg-12"}>
                                <InputItem
                                    val={appealReply }
                                    mode={"ei"}
                                    info={"Ответ"}
                                    title={""}
                                    titleShift={-6}
                                    inputType={2}
                                    lineCount={5}
                                    placeHolder={"Ответ"}
                                    onChange={(e)=>setAppealReply(e)}
                                ></InputItem>
                            </div>

                        </div>

                        <div className={styles.errCont}>
                            <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                        </div>

                        <div className={"row"}>
                            <div className={styles.actCont} style={{maxHeight:"40px"}}>

                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>handleReply()}
                                            disabled={ldrAppealReply}
                                    >Отправить</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowReply(false)}
                                            disabled={ldrAppealReply}
                                    >Отмена</button>
                                </div>
                                <WaitLoader loading={ldrAppealReply} api={rsAppealReply} onlyLoading={true}>

                                </WaitLoader>


                            </div>


                        </div>


                    </MainFormTemplate>
                )
            case 1:
            case 5:
            case 6:
            case 7:

                return(
                    <MainFormTemplate title={`Закрыть обращение`} maxWidth={"500px"} background={"white"}>
                        <div className={"row mt-3"}>
                            <div className={"col-lg-12"}>
                                <InputItem
                                    val={comment }
                                    mode={"ei"}
                                    info={"Комментарий"}
                                    title={""}
                                    titleShift={-6}
                                    inputType={2}
                                    lineCount={3}
                                    placeHolder={"Комментарий"}
                                    onChange={(e)=>setComment(e)}
                                ></InputItem>
                            </div>

                        </div>
                        <div className={styles.errCont}>
                            <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                        </div>
                        <div className={"row"}>
                            <div className={styles.actCont} style={{maxHeight:"40px"}}>

                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>handleFix()}
                                            disabled={ldrAppealReply}
                                    >Отработано</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowReply(false)}
                                            disabled={ldrAppealReply}
                                    >Отмена</button>
                                </div>
                                <WaitLoader loading={ldrAppealFix} api={rsAppealReply} onlyLoading={true}>

                                </WaitLoader>


                            </div>


                        </div>
                    </MainFormTemplate>
                )
            default:
                return(
                    <MainFormTemplate title={``} maxWidth={"500px"} background={"white"}>
                        <div className={"d-flex align-items-center justify-content-center"}>Не известный тип события</div>
                    </MainFormTemplate>
                )


        }

    }


    const buildRoot = ()=>{
        const root = appealListTree?.filter((item)=>item?.parent === 0)
        const sb = root?.sort((a,b)=>{
            const dtA = new Date(a?.createdAt)
            const dtB = new Date(b?.createdAt)
            if(dtA < dtB) return 1
            if(dtA >  dtB) return -1
            return  0
        })
        if(sb?.length === 0) return  null
        return sb?.map((item,idx)=>{
            return(
                <div className={styles.appRoot} key={idx}>
                    {buildTree(item, item.id,0)}
                </div>
            )
        })
    }


    const updateReplyState = (id: number)=>{
        console.log(`update ${id}`)
        const x = appealList?.map((item)=>{
            if(item?.id === id) item.reply = true
            return item
        })
        setAppealList(x)
    }

    const loadTree = () =>{

        if(currentRootAppeal === undefined)
        {
            setAppealListTree([])
            return
        }

        //setCurrentRootAppeal(record)
        const id = currentRootAppeal?.id
        appealListTreeData.current = {
            id:id
        }
        console.log("call",appealListTreeData.current,currentRootAppeal)
        exAppealListTree().then((e)=>{
            if(e?.success)
            {
                setAppealListTree(e?.payload)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки списка сообщений",true,5000)

        })
    }

    const handleFilter = (type:number)=>
    {
        setFltrAppealList(appealList.filter((item)=>item?.type === type))
    }

    return(
        <div className={styles.mainCont}>

            {showReply  && currentRootAppeal &&
                <ModalWindow onClose={()=>setShowReply(false)}>
                    {buildReplyJSX(currentRootAppeal?.type)}
                </ModalWindow>
            }
            <div className={styles.fltCont}>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleFilter(7)}
                    >Пропущенные</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleFilter(6)}
                    >Консультации</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                        onClick={()=>handleFilter(1)}
                    >Сайт</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                        onClick={()=>handleFilter(0)}
                    >Тарифы</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleFilter(2)}
                    >Заказы</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleFilter(4)}
                    >Возвраты</button>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleFilter(5)}
                    >Дозвон</button>
                </div>
                <div className={styles.ldrCont}>
                    <WaitLoader loading={ldrAppeal || ldrAppealListTree || ldrAppealRemove || ldrAppealVisible} api={rsAppeal} onlyLoading={true}>

                    </WaitLoader>

                </div>



            </div>
            <TableItem
                onPageCount={10}
                data={fltrAppealList}
                column={tableColumn}
                exportExcel={true}
                onReload={()=>loadAppealList()}
                onRecord={(e:any)=>setCurrentRootAppeal(e)}
                baseState={{
                    state: baseState,
                    setState: setBaseState
                } }
                saveState={true}


            ></TableItem>

            <div className={styles.errCont}>
                <ErrorLineItem ref={errorLineRef}></ErrorLineItem>
            </div>
            <div className={styles.appCont}>
                {buildRoot()}
            </div>






        </div>
    )
}